//import React from 'react';
import { TextField, Grid, Box, Divider, Typography, Switch } from '@mui/material';
import { callApi } from '../../../utils/apiClient';
import { Warehouse_API_ENDPOINTS } from '../../../config/api/apiCallWarehouse';
import WarehouseTypeActionMenu from './WarehouseTypeActionMenu';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Troubleshoot } from '@mui/icons-material';
import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";

const AddUpdateWarehouseType = ({
  warehouseFormData,
  setWarehouseFormData,
  setIsFormOpen,
  LoadWarehouseList
}) => {
  const isEdit = warehouseFormData?.warehouse_type_id > 0;
  const whId = warehouseFormData?.warehouse_type_id || 0;

  //toast.dismiss();
  React.useEffect(() => {
  if (!warehouseFormData || warehouseFormData.warehouse_type_id === 0) {
    setWarehouseFormData((prev) => ({ ...prev, status: true }));
  }
}, []);


  const handleSave = async () => {
  if (!warehouseFormData.code?.trim()) {
    alert('Please enter Warehouse Type Code.');
    return;
  }
  if (!warehouseFormData.description?.trim()) {
    alert('Please enter Description.');
    return;
  }

  const payload = {
    p_id: whId,
    p_code: warehouseFormData.code,
    p_description: warehouseFormData.description,
    p_status: warehouseFormData.status ? 'true' : 'false',
    p_company_id: localStorage.getItem('companyid'),
    p_plant_id: 1,
    p_created_by: 100,
    p_updated_by: 100,
    p_status:warehouseFormData.status,
  };

  const endpoint = isEdit
    ? Warehouse_API_ENDPOINTS.warehouseType.update
    : Warehouse_API_ENDPOINTS.warehouseType.create;

  try {
    const response = await callApi(
      endpoint,
      'POST',
      { 'Content-Type': 'application/json' },
      payload
    );

   // ✅ Get the message from the API response
  const message =
   response[0]?.message ||       // fallback if API returns plain object
    "Warehouse Type saved successfully!";
//showAlert(message,"msg");
    toast.success(message, {
      position: "bottom-center",
  autoClose: 3000,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: false,
    });

    // ✅ Refresh list
    LoadWarehouseList();

    // ✅ Move form into EDIT mode with saved data
    if (!isEdit && response && response[0]?.warehouse_type_id) {
      setWarehouseFormData({
        warehouse_type_id: response[0].warehouse_type_id,
        code: warehouseFormData.code,
        description: warehouseFormData.description,
        status: warehouseFormData.status,
      });
    } else {
      // For updates, just ensure data stays in edit mode
      setWarehouseFormData((prev) => ({
        ...prev,
        warehouse_type_id: whId,
      }));
    }

  } catch (error) {
    console.error('Error saving warehouse type:', error);
    const errorMsg =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to save Warehouse Type";
    toast.error(errorMsg, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 3000,
    });
  }
};

  const handleDelete = async () => {
    if (!isEdit) return;
    const confirmed = window.confirm('Are you sure you want to delete this Warehouse Type?');
    if (!confirmed) return;

    const payload = {
      p_id: whId,
      p_code: warehouseFormData.code,
      p_description: warehouseFormData.description,
      p_company_id: localStorage.getItem('companyid'),
      p_plant_id: 1,
      p_created_by: localStorage.getItem('userID'),
      p_updated_by: localStorage.getItem('userID'),
    };

    try {
      await callApi(
        Warehouse_API_ENDPOINTS.warehouseType.delete,
        'POST',
        { 'Content-Type': 'application/json' },
        payload
      );
        
      //toast.success("Warehouse Type Deleted successfully!",{ position: toast.POSITION.BOTTOM_CENTER },{autoclose:35000});
      toast.success("Warehouse Type deleted successfully!", 
  { position: toast.POSITION.BOTTOM_CENTER }, 
  { autoClose: 3000 }
);
       LoadWarehouseList();
      // setIsFormOpen(false);
      // ✅ Clear and switch to New Entry mode
    setWarehouseFormData({
      warehouse_type_id: 0,
      code: "",
      description: "",
      status: true, // default Active
    });
    } catch (error) {
      console.error('Error deleting warehouse type:', error);
    }
  };

  const handleClear = () => {
    setWarehouseFormData({
      warehouse_type_id: 0,
      code: "",
      description: "",
      status: true,
    });
  };

  const handleExit = () => setIsFormOpen(false);

  return (
    <Box fullWidth>
      {/* Header / Action Menu */}
      <WarehouseTypeActionMenu
        isEdit={isEdit}
        onSave={handleSave}
        onDelete={handleDelete}
        onClear={handleClear}
        onExit={handleExit}
        saveDisabled={!warehouseFormData.code || !warehouseFormData.description}
      />

      <Divider />

      {/* Form Section */}
      <Box p={3}>
        <Grid container spacing={3}>
          {/* CODE ROW */}
          <Grid item xs={12}>
            <Box
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(2, 1fr)',
                sm: 'repeat(12, 1fr)',
              }}
              gap={{ xs: '20px', sm: '10px' }}
              alignItems="center"
            >
              <Box gridColumn="span 2">
                <Typography variant="h6">Code</Typography>
              </Box>
              <Box gridColumn="span 5">
                <TextField
                  fullWidth
                  size="small"
                  color="secondary"
                  placeholder="Enter Warehouse Type Code"
                  value={warehouseFormData.code}
                  onChange={(e) =>
                    setWarehouseFormData({
                      ...warehouseFormData,
                      code: e.target.value.toUpperCase(),
                    })
                  }
                   disabled={isEdit}
                />
              </Box>
            </Box>
          </Grid>

          {/* DESCRIPTION ROW */}
          <Grid item xs={12}>
            <Box
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(2, 1fr)',
                sm: 'repeat(12, 1fr)',
              }}
              gap={{ xs: '20px', sm: '10px' }}
              alignItems="center"
            >
              <Box gridColumn="span 2">
                <Typography variant="h6">Description</Typography>
              </Box>
              <Box gridColumn="span 5">
                <TextField
                  fullWidth
                  size="small"
                  color="secondary"
                  placeholder="Enter Description"
                  value={warehouseFormData.description}
                  onChange={(e) =>
                    setWarehouseFormData({
                      ...warehouseFormData,
                      description: e.target.value.toUpperCase(),
                    })
                  }
                />
              </Box>
            </Box>
          </Grid>

          {/* STATUS ROW */}
          <Grid item xs={12}>
            <Box
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(2, 1fr)',
                sm: 'repeat(12, 1fr)',
              }}
              gap={{ xs: '20px', sm: '10px' }}
              alignItems="center"
            >
              <Box gridColumn="span 2">
                <Typography variant="h6">Status</Typography>
              </Box>
             <Box gridColumn="span 5" display="flex" alignItems="center" gap={1}>
  <Switch
    checked={warehouseFormData.status === undefined ? true : warehouseFormData.status}
    color="secondary"
    onChange={(e) =>
      setWarehouseFormData({
        ...warehouseFormData,
        status: e.target.checked,
      })
    }
  />
  <Typography>
    {warehouseFormData.status === undefined
      ? "Active"
      : warehouseFormData.status
      ? "Active"
      : "Inactive"}
  </Typography>
</Box>

            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default AddUpdateWarehouseType;
